import React from 'react';

const rub = new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB', maximumFractionDigits: 0 });

const VilatteProductCard = ({ product, onOpen, compact = false }) => {
  const groups = new Map();
  for (const label of product.available_sizes || []) {
    const [size, height = ''] = String(label).split('/');
    if (!groups.has(height)) groups.set(height, new Set());
    groups.get(height).add(size);
  }

  return (
    <article className={`vilatte-card ${compact ? 'is-compact' : ''}`}>
      <button className="vilatte-card-open" type="button" onClick={() => onOpen?.(product)} aria-label={`Открыть ${product.title}`}>
        <span className="vilatte-card-image">
          <img className="vilatte-card-image-primary" src={product.main_image} alt={product.title} loading="lazy" decoding="async" />
          {product.hover_image && <img className="vilatte-card-image-hover" src={product.hover_image} alt="" loading="lazy" decoding="async" aria-hidden="true" />}
          {product.is_new && <span className="vilatte-card-badge">NEW</span>}
        </span>
        <span className="vilatte-card-body">
          <span className="vilatte-card-sizes" aria-label="Доступные размеры">
            {[...groups].sort(([a],[b]) => Number(b)-Number(a)).map(([height, sizes]) => <span className="vilatte-size-row" key={height}>
              {height && <small>{height}:</small>}
              {[...sizes].sort((a,b) => a.localeCompare(b, 'ru', {numeric:true})).map(size => <span key={size}>{size}</span>)}
            </span>)}
          </span>
          <span className="vilatte-card-title">{product.title}</span>
          {product.color && <span className="vilatte-card-color">Цвет: {product.color}</span>}
          <span className="vilatte-card-sku">Арт. {product.sku}</span>
          <span className="vilatte-card-price">
            <strong>{rub.format(product.price_rub)}</strong>
            {product.oldprice_rub > product.price_rub && <del>{rub.format(product.oldprice_rub)}</del>}
          </span>
        </span>
      </button>
    </article>
  );
};

export default VilatteProductCard;
